import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { config } from 'src/app/config';
import { SuperAdminService } from 'src/app/super-admin.service';
import { ImagePreviewComponent } from '../../LR-management/image-preview/image-preview.component';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-edit-office-expense',
  templateUrl: './edit-office-expense.component.html',
  styleUrls: ['./edit-office-expense.component.css']
})
export class EditOfficeExpenseComponent implements OnInit {
  filesToUpload: Array<File> = [];
  apiUrl= environment.domain;
  superVisor;
  company;
  vehicletypes;
  particlarExpense;
  subCat;
  paramId;
  userSessionData;
  Attachments:any;
  @ViewChild('showSlip') showSlip: ElementRef;
  slipURL: any;
  addofficeExpenseForm = new FormGroup({
    supervisorname: new FormControl('', [Validators.required]),
    expenseCategory: new FormControl('', [Validators.required]),
    companyname: new FormControl('', [Validators.required]),
    expenseDate:new FormControl('', [Validators.required]),
    expenseAmount: new FormControl('', Validators.compose([Validators.required, Validators.pattern(/^\d{1,}$/)])),
    expenseDescription: new FormControl('', [Validators.required]),
    LRReceipt1: new FormControl(''), 
  })
  
  constructor(private activatedRoute: ActivatedRoute,private router :Router, private toastr: ToastrService, private superAdminService: SuperAdminService,public dialog: MatDialog, private sanitizer:DomSanitizer,private spinner: NgxSpinnerService) {
    this.activatedRoute.params.subscribe(param => {
      this.paramId = param.id;
      this.getParticularExpense(this.paramId);
    })
  }
 ngOnInit(): void {
   this.getCompanyName();
   this.getSuperVisorName();
   this.getVehicleType();
   this.getSubCat();
   this.userSessionData = JSON.parse(sessionStorage.getItem('userSession'));
 }
 resetimg(image:any){
  switch (image) {
    case 'attechment':
      this.Attachments =''
      break;
    default:

  }
}
 getSubCat(){
  this.superAdminService.getSubCategory()
  .subscribe((res: { status: any, message: any, data: any }) => {
    if (res.status == true) {
      var rawdata = res.data;
      // this.subCat = rawdata.expenseSubCategory;
      this.subCat=rawdata.filter(word => word.expenseCategory === 'Office Expense');
      //this.dtOptions.data = this.users;
    }
    else {
      alert(res.message)
    }
  }, error => {
  });
}
 getParticularExpense(id: string) {
  this.superAdminService.getParticularExpense(id).subscribe((res: { status: any, message: any, data: any }) => {
    if (res.status == true) {
      this.particlarExpense = res.data[0];
      this.initform();
    }
    else {
      console.log(res.message)
    }

  }, error => {
  });

}
initform() {
  this.addofficeExpenseForm.patchValue({

    expenseDescription: this.particlarExpense.expenseDescription,
    expenseDate: new Date(this.particlarExpense.expenseDate).toISOString().split('T')[0],
    expenseAmount: this.particlarExpense.totalExpenseAmount,
    expenseCategory: this.particlarExpense.expenseSubCategoryId,
    supervisorname: this.particlarExpense.supervisorId,
    companyname: this.particlarExpense.companyId,
    LRReceipt1: this.particlarExpense.LRReceipt1
  })
  this.Attachments =  this.apiUrl+'/uploads/'+this.particlarExpense.attachReceipt1
  if(this.userSessionData.user_role_id[0]!=1){
    this.addofficeExpenseForm.get("supervisorname").reset(this.particlarExpense.SupervisorName);
  }
}
 getSuperVisorName(){
   this.superAdminService.getSuperVisorName()
   .subscribe((res: { status: any, message: any, data: any }) => {

     if (res.status == true) {
       var rawdata = res.data;
       this.superVisor = rawdata;
     }
     else {
      if (res.status == 401) {
        this.toastr.error(res.message);
        window.sessionStorage.clear();
        this.router.navigateByUrl('superAuth/login');
        
      }else {
        this.toastr.error(res.message);
      }
     }

   }, error => {
   });
 }
 getCompanyName(){
     this.superAdminService.getClient()
       .subscribe((res: { status: any, message: any, data: any }) => {
 
         if (res.status == true) {
           var rawdata = res.data;
           this.company = rawdata;
           //this.dtOptions.data = this.users;
         }
         else {
          if (res.status == 401) {
            this.toastr.error(res.message);
            window.sessionStorage.clear();
            this.router.navigateByUrl('superAuth/login');
            
          }else {
            this.toastr.error(res.message);
          }
         }
 
       }, error => {
       });
   
 }
 getVehicleType() {
   this.superAdminService.getVehicleType()
     .subscribe((res: { status: any, message: any, data: any }) => {

       if (res.status == true) {
         var rawdata = res.data;
         this.vehicletypes = rawdata;
       }
       else {
        if (res.status == 401) {
          this.toastr.error(res.message);
          window.sessionStorage.clear();
          this.router.navigateByUrl('superAuth/login');
          
        }else {
          this.toastr.error(res.message);
        }
       }

     }, error => {
     });

 }
 fileChangeEventattachReceipt1(fileInput: any) {

   // this.filesToUpload.push(fileInput.target.files[0]);
    this.filesToUpload=[];
    this.filesToUpload.push(fileInput.target.files[0] );
    const reader = new FileReader();
     reader.readAsDataURL(fileInput.target.files[0])
       reader.onload = () => {
         const value = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
         this.Attachments = reader.result;
       }
 }
 updateOfficeExpence() {

   if (this.addofficeExpenseForm.valid) {
     this.removevalidatorcss("supervisornamectrl");
     this.removevalidatorcss("expenseCategoryctrl");
     this.removevalidatorcss("companyNameCtrl");
     this.removevalidatorcss("expenseDatectrl");
     this.removevalidatorcss("expenseAmountctrl");
     this.removevalidatorcss("expenseDescriptionctrl");
     
     
     var form = {
      
       "supervisorId": this.addofficeExpenseForm.get('supervisorname').value,
       "expenseSubCategoryId": this.addofficeExpenseForm.get('expenseCategory').value,
       "companyId": this.addofficeExpenseForm.get('companyname').value,
       "expenseDate": this.addofficeExpenseForm.get('expenseDate').value,
       "expenseAmount": this.addofficeExpenseForm.get('expenseAmount').value,
       "expenseDescription": this.addofficeExpenseForm.get('expenseDescription').value,
       "attachReceipt1": this.particlarExpense.attachReceipt1,
       "_id":this.paramId,
       
     }
     const formData = new FormData();
      const files: Array<File> = this.filesToUpload;
     
     for (let i = 0; i < this.filesToUpload.length; i++) {
        //formData.append("uploads[]", this.filesToUpload[i]);
        formData.append("uploads[]", this.filesToUpload[i]);
      }
     //formData.append("officeExpenceAttachment", this.filesToUpload[i]);
     formData.append('myFormData', JSON.stringify(form));
      this.spinner.show();
   this.superAdminService.updateOfficeExpence(formData)
   .subscribe((res: { status: any, message: any, authorization: any, code: any }) => {
    this.spinner.hide();
       if (res.status == true) {
         //alert(res.message)
         this.toastr.success(res.message);
         this.router.navigate(['/superAdmin/officeExpense/expanceList']);
         //this.addofficeExpenseForm.reset()
       }
       else {
         this.toastr.error(res.message);
         //this.addNewUser.reset()
       }
     
   }, error => {
    this.spinner.hide();
    this.toastr.error('internal server error');
   });
   }
   else {

     if (this.addofficeExpenseForm.get('companyname').invalid) {
       this.addvalidatorcss("companyNameCtrl");
     } else {
       this.removevalidatorcss("companyNameCtrl");
     }

     if (this.addofficeExpenseForm.get('supervisorname').invalid) {
       this.addvalidatorcss("supervisornamectrl");
     } else {
       this.removevalidatorcss("supervisornamectrl");
     }
   
     
     
     
     if (this.addofficeExpenseForm.get('expenseCategory').invalid) {
       this.addvalidatorcss("expenseCategoryctrl");
     } else {
       this.removevalidatorcss("expenseCategoryctrl");
     }
     
    
     
     if (this.addofficeExpenseForm.get('expenseDescription').invalid) {
       this.addvalidatorcss("expenseDescriptionctrl");
     } else {
       this.removevalidatorcss("expenseDescriptionctrl");
     }
     if (this.addofficeExpenseForm.get('expenseDate').invalid) {
       this.addvalidatorcss("expenseDatectrl");
     } else {
       this.removevalidatorcss("expenseDatectrl");
     }
     if (this.addofficeExpenseForm.get('expenseAmount').invalid) {
       this.addvalidatorcss("expenseAmountctrl");
     } else {
       this.removevalidatorcss("expenseAmountctrl");
     }
     if (this.addofficeExpenseForm.get('LRReceipt1').invalid) {
       this.addvalidatorcss("LRReceipt1ctrl");
     } else {
       this.removevalidatorcss("LRReceipt1ctrl");
     }
     
   }
 }
 resetForm() {
  this.addofficeExpenseForm.reset();
  this.initform();
  this.filesToUpload=[];
 }
 backTo(){
   window.history.back()
 }
 addvalidatorcss(id: string) {
   document.getElementById(id).classList.add('validatorcss');
 }
 removevalidatorcss(id: string) {
   document.getElementById(id).classList.remove('validatorcss');
 }
 preview(imagePath:any){
  if(this.filesToUpload.length){
    let file = this.filesToUpload[0];
    if(['image/jpeg','image/png','image/svg','image/svg+xml'].includes(file.type)){
      const dialogRef = this.dialog.open(ImagePreviewComponent, {
        width:'80%',
        height:'90vh',
        data:{file:file}
    });
    }
    else{
      let url =URL.createObjectURL(file);
      this.slipURL = this.sanitizer.bypassSecurityTrustUrl(url);
      setTimeout(()=>{
        this.showSlip.nativeElement.click();
      })
    }
  }
  else{
    if(imagePath){
      let fileExtension=imagePath.split('.').slice(-1)[0];
      if(['jpeg','png','jpg','svg'].includes(fileExtension)){
        const dialogRef = this.dialog.open(ImagePreviewComponent, {
          width:'80%',
          height:'90vh',
          data:{file:'/uploads/'+imagePath}
      });
      }
      else{
        this.slipURL = this.sanitizer.bypassSecurityTrustUrl(this.apiUrl+'/uploads/'+imagePath);
        setTimeout(()=>{
          this.showSlip.nativeElement.click();
        })
      }
    }
    else{
      this.toastr.error('No Slip Attached')
    }
  }
}

}
